import moment from 'moment';
import React, {useState} from 'react';
import {
  Alert,
  Modal,
  PermissionsAndroid,
  Platform,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import RNFS from 'react-native-fs';
import Feather from 'react-native-vector-icons/Feather';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {Colors} from '../../../../constants/Colors';
import AuthService from '../../../../services/AuthService/AuthService';
import {styles} from './styles';
import { showSuccess } from '../../../../utils/globalAlert';

interface IModalFilter {
  visible: boolean;
  onRequestClose: () => void;
  item: IStatusPedido;
  returnSort: (val: string) => void;
}

const TransitModal = ({
  visible,
  onRequestClose,
  item,
  returnSort,
}: IModalFilter) => {
  const verifyOrderType = {
    ZS03: 'Bonificação',
    ZS11: 'Troca',
    ZS43: 'Compra',
  };

  async function requestWritePermission() {
    if (Platform.OS === 'android') {
      try {
        const granted = await PermissionsAndroid.request(
          PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
          {
            title: 'Permissão de escrita',
            message:
              'Este aplicativo precisa de permissão para salvar arquivos.',
            buttonNeutral: 'Pergunte-me depois',
            buttonNegative: 'Cancelar',
            buttonPositive: 'OK',
          },
        );
        return granted === PermissionsAndroid.RESULTS.GRANTED;
      } catch (err) {
        console.warn(err);
        return false;
      }
    }
    return true;
  }

  const downloadInvoice = async () => {
    const hasPermission = true;
    if (!hasPermission) {
      Alert.alert(
        'Permissão negada',
        'Não foi possível baixar o arquivo sem permissão.',
      );
      return;
    }

    try {
      // Fazer a requisição para a API que retorna o PDF
      const response = await AuthService.postNotaFiscal(
        item.Notas.Nota.CHAVE_NF,
      );

      const path = `${RNFS.DownloadDirectoryPath}/nota_fiscal.pdf`;

      // Salva o arquivo
      await RNFS.writeFile(path, response, 'base64');
      showSuccess('Sucesso', `PDF baixado e salvo em: ${path}`);
    } catch (error) {
      console.error(error);
      Alert.alert('Erro', 'Falha ao baixar o PDF');
    }
  };

  const [sort, setSort] = useState<boolean>(false);
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
            <View style={styles.containerConfirmed}>
              <Text style={styles.filterTitle}>Pedido em trânsito</Text>
            </View>
          </View>
          <ScrollView style={styles.containerDrop}>
            <Text style={styles.orderText}>
              Pedido: {item?.['@attributes']?.ORDEM}
            </Text>

            <Text style={styles.codeText}>
              <Text style={{color: Colors.GrayPallete.lightGrayFour}}>
                Frota
              </Text>
              {'   '}
              {item?.Transporte?.FROTA?.replace(/^0+/, '')}
            </Text>
            <Text style={styles.codeText}>
              <Text style={{color: Colors.GrayPallete.lightGrayFour}}>
                Placa
              </Text>
              {'   '}
              {item?.Transporte?.PLACA}
            </Text>
            <Text style={styles.codeText}>
              <Text style={{color: Colors.GrayPallete.lightGrayFour}}>
                Nome do motorista
              </Text>
            </Text>
            <Text style={styles.codeTextCont}>
              {item?.Transporte?.MOTORISTA_NOME}
            </Text>
            <Text style={styles.codeText}>
              <Text style={{color: Colors.GrayPallete.lightGrayFour}}>
                Tel. Motorista
              </Text>
              {'   '}
              {item?.Transporte?.MOTORISTA_TEL?.length > 0 ? (
                Array.isArray(item?.Transporte?.MOTORISTA_TEL) ? (
                  item?.Transporte?.MOTORISTA_TEL.map((item, index) => (
                    <Text style={styles.codeTextCont} key={index}>
                      {item}
                    </Text>
                  ))
                ) : (
                  <Text style={styles.codeTextCont}>
                    {item?.Transporte?.MOTORISTA_TEL}
                  </Text>
                )
              ) : (
                <Text style={styles.codeTextCont}>Indisponível</Text>
              )}
            </Text>
          </ScrollView>
          <View style={styles.containerButton}></View>
        </View>
      </View>
    </Modal>
  );
};

export default TransitModal;
